import Dispatcher from '../dispatcher';
import {FSFNotAvailableLightBoxActions} from '../constants/fsf_not_available_light_box/fsf_not_available_light_box_actions';

function showAction() {
    Dispatcher.handleFSFNotAvailableLightboxAction({
        type: FSFNotAvailableLightBoxActions.SHOW
    });
}

function hideAction() {
    Dispatcher.handleFSFNotAvailableLightboxAction({
        type: FSFNotAvailableLightBoxActions.HIDE
    });
}

export {
    showAction,
    hideAction
};